import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  hasImageURLFilterOptions,
  productTypeFilterOptions,
  alertFilterOptions,
  trackedFilterOptions,
  isBundleFilterOptions,
} from '../messages';

const buildCriterionArgumentObject = (id, displayMessage, value) => {
  return {
    id,
    displayName: <FormattedMessage {...displayMessage} />,
    value,
  };
};

const ProductTypeEnum = {
  standalone: 1,
  parent: 2,
};

const AlertsEnum = {
  noAlerts: 0,
  reorderThresholdMet: 1,
  noInventory: 2,
};

const TrackedEnum = {
  tracked: true,
  notTracked: false,
};

export default {
  thumbnailUrl: Object.keys(hasImageURLFilterOptions).map((key) =>
    buildCriterionArgumentObject(key, hasImageURLFilterOptions[key], key === 'hasURL'),
  ),
  productType: Object.keys(productTypeFilterOptions).map((key) =>
    buildCriterionArgumentObject(key, productTypeFilterOptions[key], ProductTypeEnum[key]),
  ),
  alerts: Object.keys(AlertsEnum).map((key) => buildCriterionArgumentObject(key, alertFilterOptions[key], AlertsEnum[key])),
  tracked: Object.keys(TrackedEnum).map((key) => buildCriterionArgumentObject(key, trackedFilterOptions[key], TrackedEnum[key])),
  bundle: Object.keys(isBundleFilterOptions).map((key) =>
    buildCriterionArgumentObject(key, isBundleFilterOptions[key], key === 'isBundle'),
  ),
};
